import { AlertTrigger, schPairedCostRouteItem } from '@aloft/toolkit-shared';

import { SUBNAV_ALERT_TRIGGERS } from './constants.ts';

export type SubnavAlertTriggerRoute = (typeof schPairedCostRouteItem.options)[number];

export const getAlertTriggerForRoute = (
  route: SubnavAlertTriggerRoute,
): AlertTrigger | undefined => SUBNAV_ALERT_TRIGGERS[route];
